import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';

import { useAddDraftInvestorModal } from '../context/AddDraftInvestorModalContext';
import ProportionalitySection from './ProportionalitySection';

const CapitalIncreaseOptionsSection: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddDraftInvestorModal();

  const hasManualContribution = data.proportionalityType === '';

  return (
    <>
      <div className="form-group">
        <div className="custom-control custom-checkbox checked">
          <input
            type="checkbox"
            id="has-manual-contribution-checkbox"
            className="custom-control-input"
            checked={data.hasNotAdjustedContribution}
            onChange={actions.handleChangeHasNotAdjustedContribution}
            disabled={!hasManualContribution}
          />
          <label
            className="custom-control-label"
            htmlFor="has-manual-contribution-checkbox"
          >
            {t('ContributionNotRound')}
          </label>

          <IconTooltip
            id="has-manual-contribution-tooltip"
            tooltip={t('ContributionNotRoundTooltip')}
            place="top"
          />
        </div>
      </div>

      <ProportionalitySection />
    </>
  );
};

export default CapitalIncreaseOptionsSection;
